import React,{ Component } from "react";
import { connect } from "react-redux";
import { updateImages } from "../../../actions/actionImage";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import ImageForm from "../ImageForm/ImageForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Images",path:"/workspaces",isActive: false},
    {name: "UpdateImages",path:"/updateworkspace",isActive: true},
];

class UpdateImage extends Component{
    render(){
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>      
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update Workspace</strong>
                                </CardHeader>
                                <ImageForm
                                    updateImages={this.props.updateImages}
                                    imageId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateImage.propTypes = {
    updateImages: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
    images: state.images.images || []
}), 
dispatch => ({
    updateImages: () => dispatch(updateImages())
}))(UpdateImage);